export default __webpack_public_path__ + "static/illustration-content-logo.url-303374fcd7d3e6c5890d17d941fe507c.svg";